module.exports = __webpack_public_path__ + "img/wide.6404658b.jpg";